import { BatchesService } from '@festina/life-general-types/life/services/BatchesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method = BatchesService.batchesServicePostCreate
export type MethodParam = NonNullable<
  Parameters<typeof method>[0]['requestBody']
>

export const useSubmitLifeBatch = () =>
  useFestinaMutation({
    component: 'life',
    roles: BatchesService.batchesServicePostCreate_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({ requestBody: arg })
    },
  })
